<template>
    <div class="container" id="EnrollDetail">
        <el-page-header @back="$router.back()" :content="['创建赛事报名设置','编辑赛事报名设置','查看报名设置信息'][type]"></el-page-header>
        <div class="EnrollDetail_content">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
                <el-form-item label="赛事:" prop="subLeagueId" v-if="type == 0">
                    <el-select v-model="subLeagueId" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in leagueList" :key="index"
                            :label="item.SubLeagueName"
                            :value="item.SubLeagueId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赛事名称:" v-else>{{leagueObj.SubLeagueName}}</el-form-item>
                <template v-if="subLeagueId && subLeagueId > 0">
                    <el-form-item label="比赛时间:">
                        <template v-if="leagueObj.GameBeginTime && leagueObj.GameEndTime">
                            {{leagueObj.GameBeginTime | dateFormat('yyyy-MM-dd HH:mm:ss')}} ~ {{leagueObj.GameEndTime | dateFormat('yyyy-MM-dd HH:mm:ss')}}
                        </template>
                        <template v-else>未定</template>
                    </el-form-item>
                    <el-form-item label="报名时间:" prop="time" v-if="leagueObj.GameBeginTime && leagueObj.GameEndTime">
                        <el-date-picker
                            v-model="form.time"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-ddTHH:mm:ss"
                            :picker-options="GameTimeOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="报名时间:" prop="time" v-else>
                         <el-date-picker
                            v-model="form.time[0]"
                            type="datetime"
                            placeholder="开始日期"
                            value-format="yyyy-MM-ddTHH:mm:ss"
                            :picker-options="startGameTimeOptions">
                         </el-date-picker>
                         <span>&ensp;至&ensp;</span>
                         <el-date-picker
                            v-model="form.time[1]"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-ddTHH:mm:ss"
                            :picker-options="endGameTimeOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="报名须知:" prop="detail">
                        <Editor v-model="form.detail" :oss-options="UploaderOptions"></Editor>
                    </el-form-item>
                    <el-form-item label="上传图片附件:">
                        <Images 
                            v-model="attachmentImages"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Images>
                    </el-form-item>
                    <el-form-item label="上传文档附件:">
                        <Files 
                            label="文档附件"
                            v-model="attachmentFiles"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Files>
                    </el-form-item>
                    <el-divider></el-divider>
                    <el-descriptions title="报名限制设置"></el-descriptions>
                    <div class="enrollOptions">
                        <el-form-item label="运动员报名限制:" label-width="130px" style="margin-bottom:20px">
                            <el-radio-group v-model="enrollOptions.athleteEnrollLimit" border>
                                <p><el-radio :label="0">可以同时报名团体组别和个人/双人组别，也可以只报名一种。</el-radio></p>
                                <p><el-radio :label="1">必须先报名团体组别，才能报名个人/双人组别;也可以只报名团体组别。</el-radio></p>
                                <p><el-radio :label="2">不能同时报名团体组别和个人/双人组别，只能报名其中一种。</el-radio></p>
                            </el-radio-group>
                            <p>最多能同时报名的团体组别数量: <el-input v-model.number="enrollOptions.athleteTeamgroupNumber"></el-input></p>
                            <p>最多能同时报名的个人/双人组别数量: <el-input v-model.number="enrollOptions.athleteSinglegroupNumber"></el-input></p>
                        </el-form-item>
                        <el-form-item label="代表队报名限制:" label-width="130px">
                            <el-radio-group v-model="enrollOptions.teamEnrollLimit" border>
                                <p><el-radio :label="0">可以同时报名团体组别和个人/双人组别，也可以只报名一种。</el-radio></p>
                                <p><el-radio :label="1">必须先报名团体组别，才能报名个人/双人组别;也可以只报名团体组别。</el-radio></p>
                            </el-radio-group>
                            <p>最多能同时报名的团体组别数量: <el-input v-model.number="enrollOptions.teamTeamgroupNumber"></el-input></p>
                        </el-form-item>
                    </div>
                    <el-divider></el-divider>
                    <el-descriptions title="队员信息设置"></el-descriptions>
                    <div class="fields">
                        <el-form-item :label="`${item.label}:`" v-for="item,index in fields" :key="index">
                            <el-radio-group v-model="fieldsOptions[item.key]">
                                <el-radio v-for="option,optionIndex in item.options" :key="optionIndex" :label="option.value">{{option.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <el-divider></el-divider>
                    <el-descriptions title="队员身份设置"></el-descriptions>
                    <div class="role">
                        <ul>
                            <li v-for="(item,index) in roleList" :key="index">
                                <div>
                                    <el-checkbox v-model="item.isExist" :disabled="item.isAthlete == 1">
                                        <span v-if="item.name">{{item.name}}</span>
                                        <el-input v-model.trim="item.nameValue" maxlength="10" v-else></el-input>
                                    </el-checkbox>
                                </div>
                                <div>
                                    <span>人数限制：最少：</span>
                                    <el-input v-model.number="item.min"></el-input>人
                                    <span>~</span>
                                    <span>最多：</span><el-input v-model.number="item.max"></el-input>人
                                </div>
                                <div v-if="item.isAthlete != 1">
                                    <el-checkbox v-model="item.isMerger">可兼任运动员</el-checkbox>
                                </div>
                                <div v-if="!item.name">
                                    <el-button type="danger" @click="removeRole(index)" size="mini" style="margin-left:20px">删除</el-button>
                                </div>
                            </li>
                        </ul>
                        <el-button type="primary" size="small" @click="addRole()" title="点击添加一行身份填写"><i class="el-icon-plus"></i> 增加身份</el-button>
                    </div>
                    <template v-for="(item,index) in groups">
                        <el-divider :key="'a'+index"></el-divider>
                        <el-descriptions :title="item.LeagueGroupName + '设置'" :key="'b'+index"></el-descriptions>
                        <div class="group_limit" :key="'c'+index">
                            <el-form-item label="运动员性别限制:" label-width="130px" required style="margin-bottom:20px">
                                <el-radio-group v-model="item.GenderLimit" border>
                                    <template v-if="item.GroupType != 3">
                                        <el-radio :label="1">男</el-radio>
                                        <el-radio :label="2">女</el-radio>
                                    </template>
                                    <template v-else>
                                        <el-radio :label="1">男双（二男）</el-radio>
                                        <el-radio :label="2">女双（二女）</el-radio>
                                        <el-radio :label="4">混双（一男一女）</el-radio>
                                    </template>
                                    <el-radio :label="3">男女不限</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <template v-if="[1,3,4].includes(item.GenderLimit)">
                                <el-form-item :label="([3,4].includes(item.GenderLimit)?'男':'') + '运动员年龄限制:'" 
                                label-width="130px" 
                                :prop="'maleBirthday'+index" 
                                :rules="rules.birthday"  
                                style="margin-bottom:20px">
                                    <div class="more">
                                        <div>
                                            <span class="label">最早出生：</span>
                                            <el-input v-model.number="item.MaleBirthdayMin[0]"></el-input>年
                                            <el-input v-model.number="item.MaleBirthdayMin[1]"></el-input>月
                                            <el-input v-model.number="item.MaleBirthdayMin[2]"></el-input>日
                                        </div>
                                        <div>
                                            <span class="label">最晚出生：</span>
                                            <el-input v-model.number="item.MaleBirthdayMax[0]"></el-input>年
                                            <el-input v-model.number="item.MaleBirthdayMax[1]"></el-input>月
                                            <el-input v-model.number="item.MaleBirthdayMax[2]"></el-input>日
                                        </div>
                                    </div>
                                </el-form-item>
                            </template>
                            <template v-if="[2,3,4].includes(item.GenderLimit)">
                                <el-form-item :label="([3,4].includes(item.GenderLimit)?'女':'') + '运动员年龄限制:'" 
                                label-width="130px" 
                                :prop="'femaleBirthday'+index" 
                                :rules="rules.birthday" 
                                style="margin-bottom:20px">
                                    <div class="more">
                                        <div>
                                            <span class="label">最早出生：</span>
                                            <el-input v-model.number="item.FemaleBirthdayMin[0]"></el-input>年
                                            <el-input v-model.number="item.FemaleBirthdayMin[1]"></el-input>月
                                            <el-input v-model.number="item.FemaleBirthdayMin[2]"></el-input>日
                                        </div>
                                        <div>
                                            <span class="label">最晚出生：</span>
                                            <el-input v-model.number="item.FemaleBirthdayMax[0]"></el-input>年
                                            <el-input v-model.number="item.FemaleBirthdayMax[1]"></el-input>月
                                            <el-input v-model.number="item.FemaleBirthdayMax[2]"></el-input>日
                                        </div>
                                    </div>
                                </el-form-item>
                            </template>
                            <el-form-item label="运动员人数限制:" label-width="130px" v-if="item.GroupType != 3" :key="1">
                                <div class="more number">
                                    <div>
                                        <span class="label">最少：</span>
                                        <el-input v-model.number="item.AthletesMin" :disabled="item.GroupType == 1"></el-input>人
                                    </div>
                                    <span>~</span>
                                    <div>
                                        <span class="label">最多：</span>
                                        <el-input v-model.number="item.AthletesMax"></el-input>人
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="运动员组合对数限制:" label-width="130px" v-else :key="2">
                                <div class="more number">
                                    <div>
                                        <span class="label">最少：</span>
                                        <el-input v-model.number="item.AthletesMin" disabled></el-input>对
                                    </div>
                                    <span>~</span>
                                    <div>
                                        <span class="label">最多：</span>
                                        <el-input v-model.number="item.AthletesMax"></el-input>对
                                    </div>
                                </div>
                            </el-form-item>
                            <template v-if="item.GroupType != 3 && [3].includes(item.GenderLimit)">
                                <el-form-item label="其中，男运动员人数:" label-width="160px">
                                    <div class="more number">
                                        <div>
                                            <span class="label">最少：</span>
                                            <el-input v-model.number="item.MaleAthletesMin"></el-input>人
                                        </div>
                                        <span>~</span>
                                        <div>
                                            <span class="label">最多：</span>
                                            <el-input v-model.number="item.MaleAthletesMax"></el-input>人
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="女运动员人数:" label-width="160px">
                                    <div class="more number">
                                        <div>
                                            <span class="label">最少：</span>
                                            <el-input v-model.number="item.FemaleAthletesMin"></el-input>人
                                        </div>
                                        <span>~</span>
                                        <div>
                                            <span class="label">最多：</span>
                                            <el-input v-model.number="item.FemaleAthletesMax"></el-input>人
                                        </div>
                                    </div>
                                </el-form-item>
                            </template>
                            <el-form-item label="报名方式:" :prop="`enrollWay${index}`" :rules="rules.enrollWay" style="margin-bottom:20px">
                                <el-checkbox-group v-model="item.EnrollWay" :disabled="item.GroupType == 2">
                                    <el-checkbox :label="1">代表队报名</el-checkbox>
                                    <el-checkbox :label="2">个人报名</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="组别说明:">
                                <el-input type="textarea" resize="none" :rows="3" v-model="item.LeagueGroupDesc" style="width: 100%;max-width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item label="名额限制:" :prop="`enrollQuotaLimit${index}`" :rules="rules.enrollQuotaLimit">
                                <el-radio-group v-model="item.EnrollQuotaLimitRadio">
                                    <el-radio :label="false">不限</el-radio>
                                    <el-radio :label="true">
                                        限制最多
                                        <el-input type="number" v-model.number="item.EnrollQuotaLimit" @change="enrollQuotaLimitChange($event, index)" style="width: 50px"></el-input>
                                        <template v-if="item.GroupType == 1">名运动员</template>
                                        <template v-else-if="item.GroupType == 2">支队伍</template>
                                        <template v-else-if="item.GroupType == 3">对组合</template>
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </template>
                    <el-divider></el-divider>
                    <el-descriptions title="法律文件设置"></el-descriptions>
                    <el-form-item>
                        <Files 
                            label="法律文件"
                            v-model="legalFiles"
                            :fileType="['pdf']"
                            :fileMax="99"
                            :fileSize="100 * 1024 * 1024" 
                            :inputMaxlength="20"
                            :uploaderOptions="UploaderOptions"
                        ></Files>
                    </el-form-item>
                </template>
            </el-form>
            <el-divider></el-divider>
            <el-row style="margin:30px 0 20px 100px">
                <el-button type="success" @click="save()" style="width:100px">保存</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import {
    GetCreateLeagueEnrollInitInfo,
    GetLeagueEnrollDetail,
    GetTeamUserRoleList,
    CreateLeagueEnroll,
    EditLeagueEnroll,
    GetLastLeagueEnrollDetail,
    GetLeagueEventsGroup
} from '@/api'
import {
    dateFormat
} from '@/assets/js';
import Files from '@/components/common/Files';
import Images from '@/components/common/Images';
import Editor from '@/components/Editor';
export default {
    components: {
        Files,
        Images,
        Editor
    },
    data(){
        var leagueEnrollId = parseInt(this.$route.params.leagueEnrollId),
            subLeagueId = parseInt(this.$route.params.subLeagueId),
            type = parseInt(this.$route.params.type);
        return {
            type: isNaN(type) ? 0 : type,//0 创建 1 修改
            Id: isNaN(leagueEnrollId) ? 0 : leagueEnrollId,
            subLeagueId: isNaN(subLeagueId) ? null : subLeagueId,
            leagueList:[],
            leagueObj:{},
            form:{
                time:[],
                detail:"",
            },
            fieldsOptions: {
                identity_limit:0,
                sex_limit: 1,
                birthday_limit: 1,
                portrait_photo: 0,
                jersey_number: 0
            },
            roleList:[],
            groups:[],
            legalFiles:[],
            UploaderOptions:{},
            enrollOptions: {
                teamEnrollLimit: 0,
                teamTeamgroupNumber: '',
                athleteEnrollLimit: 0,
                athleteTeamgroupNumber: '',
                athleteSinglegroupNumber: ''
            },
            attachmentImages: [],
            attachmentFiles: []
        }
    },
    created(){
        GetCreateLeagueEnrollInitInfo({
            LeagueEnrollId: this.Id
        }).then(data=>{
            if(data.Code == 0){
                this.UploaderOptions = data.UploadOption;
                if(this.type == 0){
                    this.Id = data.LeagueEnrollId;
                    this.leagueList = data.LeagueList;
                }
            }
        })
        if(this.type == 1){
            GetLeagueEnrollDetail({
                LeagueEnrollId: this.Id,
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.setData(data.SettingDetail);
                }
            })
        }
    },
    watch:{
        subLeagueId(newVal){
            if(newVal > 0){
                this.leagueObj = this.leagueList.filter(n=>n.SubLeagueId == newVal)[0];
                this.roleList = [];
                this.files = [];
                GetLastLeagueEnrollDetail({
                    SubLeagueId: this.subLeagueId
                }).then(data=>{
                    if(data.Code == 0){
                        if(data.SettingDetail){
                            let {
                                BaseInfo: {
                                    FieldsOptions,
                                    EnrollOptions
                                },
                                RoleInfo,
                                GroupInfo
                            } = data.SettingDetail;
                            this.initFieldsOptions(FieldsOptions);
                            this.initEnrollOptions(EnrollOptions);
                            this.getTeamUserRoleList(RoleInfo);
                            this.getLeagueEventsGroup(GroupInfo);
                        }else{
                            this.getTeamUserRoleList();
                            this.getLeagueEventsGroup();
                        }
                    }
                })
            }
        }
    },
    computed:{
        rules(){
            return {
                subLeagueId:[
                    {required:true,validator:(rule, value, callback)=>{
                        if(this.subLeagueId == null){
                            callback(new Error('请选择赛事'));
                        }else{
                            callback();
                        }
                    }}
                ],
                time:[
                    {required:true,validator:(rule, value, callback)=>{
                        if(!value || value.length == 0){
                            callback(new Error('请选择报名时间'));
                        }else if(!(this.leagueObj.GameBeginTime && this.leagueObj.GameEndTime) && !value[0]){
                            callback(new Error('请选择报名开始时间'));
                        }else{
                            callback();
                        }
                    }}
                ],
                birthday:[
                    {validator:(rule, value, callback)=>{
                        var index = parseInt(rule.field.substr(-1));
                        var obj = this.groups[index];
                        var y = new Date().getFullYear(),
                            min = [],
                            max = [],
                            error = null;
                        if(rule.field.indexOf('femaleBirthday') > -1){
                            min = obj.FemaleBirthdayMin,
                            max = obj.FemaleBirthdayMax;
                        }else{
                            min = obj.MaleBirthdayMin,
                            max = obj.MaleBirthdayMax;
                        }
                        let minY = min[0], minM = min[1], minD = min[2],
                            maxY = max[0], maxM = max[1], maxD = max[2];
                        if((minY && minY > y) || (maxY && maxY > y)){
                            error = '出生年份不能大于今年';
                        }else if((minY && minY < 1900) || (maxY && maxY < 1900)){
                            error = '出生年份不能小于1900年';
                        }else if(minY && maxY && minY > maxY){
                            error = '最早出生年份不能大于最晚出生年份';
                        }else if(minY && new Date(`${minY}-${minM}-${minD}`) == 'Invalid Date'){
                            error = '最早出生日期格式不正确';
                        }else if(maxY && new Date(`${maxY}-${maxM}-${maxD}`) == 'Invalid Date'){
                            error = '最晚出生日期格式不正确';
                        }
                        if(error){
                            callback(new Error(error));
                        }else{
                            callback();
                        }
                    }, trigger: 'blur'}
                ],
                enrollWay:[
                    {required:true,validator:(rule, value, callback)=>{
                        var index = parseInt(rule.field.substr(-1));
                        value = this.groups[index].EnrollWay;
                        if(!value || value.length == 0){
                            callback(new Error('请选择报名方式'));
                        }else{
                            callback();
                        }
                    }}
                ],
                enrollQuotaLimit:[
                    {validator:(rule, value, callback)=>{
                        var index = parseInt(rule.field.substr(-1));
                        if(this.groups[index].EnrollQuotaLimitRadio){
                            value = this.groups[index].EnrollQuotaLimit;
                            if(value && (value < 1 || value > 9999)){
                                callback(new Error('只能输入1~9999的正整数'));
                            }else{
                                callback();
                            }
                        }else{
                            callback();
                        }
                    }}
                ],
                detail:[
                    {validator:(_, value, callback)=>{
                        if((this.attachmentImages.length > 0 || this.attachmentFiles.length > 0) && !value){
                            callback(new Error('上传附件，必须填写报名须知'));
                        }else{
                            callback();
                        }
                    }}
                ]
            }
        },
        fieldList(){
            return [{
                isExist:true,
                name:"姓名",
                existDisabled:true,
                isRequired:1
            },{
                isExist:true,
                name:"手机号",
                existDisabled:true,
                isRequired:1
            },{
                isExist:true,
                name:"证件类型",
                existDisabled:true,
                children:{
                    list:[{
                            text:'身份证',
                            disabled:true
                        },{
                            text:'护照'
                        }],
                    value:['身份证','护照']
                },
                isRequired:1
            },{
                isExist:true,
                name:"证件号码",
                existDisabled:true,
                isRequired:1
            },{
                isExist:true,
                name:"出生日期",
                existDisabled:true,
                isRequired:1
            },{
                isExist:true,
                name:"性别",
                existDisabled:true,
                isRequired:1
            },{
                isExist:false,
                name:"证件照片",
                existDisabled:false,
                isRequired:0
            },{
                isExist:false,
                name:"肖像照片",
                existDisabled:false,
                isRequired:0
            }]
        },
        GameTimeOptions(){
            var _this = this;
            return {
                disabledDate(time){
                    return time.getTime() > new Date(_this.leagueObj.GameBeginTime).getTime();
                }
            }
        },
        startGameTimeOptions(){
            var _this = this;
            return {
                disabledDate(time){
                    if(_this.form.time[1]){
                        return time.getTime() > new Date(_this.form.time[1]).getTime();
                    }else{
                        return false;
                    }
                }
            }
        },
        endGameTimeOptions(){
            var _this = this;
            return {
                disabledDate(time){
                    if(_this.form.time[0]){
                        return time.getTime() < new Date(_this.form.time[0]).getTime();
                    }else{
                        return false;
                    }
                }
            }
        },
        fields(){
            return [
                {
                    label: '球衣号码',
                    key: 'jersey_number',
                    options: [
                        {label: '不使用', value: 0},
                        {label: '使用（仅对球员）', value: 1}
                    ]
                }, {
                    label: '肖像照',
                    key: 'portrait_photo',
                    options: [
                        {label: '不要求必须上传', value: 0},
                        {label: '运动员必须上传，其他身份不要求必须上传', value: 1},
                        {label: '所有队员必须上传', value: 9}
                    ]
                }, {
                    label: '身份证号码',
                    key: 'identity_limit',
                    options: [
                        {label: '不要求必填', value: 0},
                        {label: '运动员必填，其他身份不要求必填', value: 1},
                        {label: '所有队员必填', value: 9}
                    ]
                }, {
                    label: '性别',
                    key: 'sex_limit',
                    options: [
                        {label: '不要求必填', value: 0},
                        {label: '运动员必填，其他身份不要求必填', value: 1},
                        {label: '所有队员必填', value: 9}
                    ]
                }, {
                    label: '出生日期',
                    key: 'birthday_limit',
                    options: [
                        {label: '不要求必填', value: 0},
                        {label: '运动员必填，其他身份不要求必填', value: 1},
                        {label: '所有队员必填', value: 9}
                    ]
                }
            ]
        }
    },
    methods:{
        setData(settingDetail){
            if(!settingDetail)return;
            let {
                LeagueBaseInfo,
                BaseInfo: {
                    EnrollBeginTime,
                    EnrollEndTime,
                    EnrollNotice,
                    FieldsOptions,
                    EnrollOptions
                },
                RoleInfo,
                GroupInfo,
                InstrumentInfo,
                DocFiles,
                PictureFiles
            } = settingDetail;
            this.leagueObj = LeagueBaseInfo;
            let form = {
                time: [EnrollBeginTime, EnrollEndTime],
                detail: EnrollNotice
            }
            this.form = form;
            this.initFieldsOptions(FieldsOptions);
            this.initEnrollOptions(EnrollOptions);
            //角色
            this.getTeamUserRoleList(RoleInfo);
            //分组
            this.groups = GroupInfo.map(item=>{
                let {
                    LeagueGroupId,
                    EventsId,
                    LeagueGroupName,
                    LeagueGroupDesc,
                    GroupType,
                    EnrollWay: EWay,
                    GenderLimit,
                    MaleBirthdayMin: MBMin,
                    MaleBirthdayMax: MBMax,
                    FemaleBirthdayMin: FBMin,
                    FemaleBirthdayMax: FBMax,
                    AthletesMin,
                    AthletesMax,
                    MaleAthletesMin,
                    MaleAthletesMax,
                    FemaleAthletesMin,
                    FemaleAthletesMax,
                    EnrollQuotaLimit
                } = item;
                let EnrollWay = [];
                if([1,3].indexOf(EWay) > -1){
                    EnrollWay.push(1);
                }
                if([2,3].indexOf(EWay) > -1){
                    EnrollWay.push(2);
                }
                let MaleBirthdayMin = MBMin ? this.setDate(MBMin) : [null, 1, 1],
                    MaleBirthdayMax = MBMax ? this.setDate(MBMax) : [null, 12, 31],
                    FemaleBirthdayMin = FBMin ? this.setDate(FBMin) : [null, 1, 1],
                    FemaleBirthdayMax = FBMax ? this.setDate(FBMax) : [null, 12, 31];
                return {
                    LeagueGroupId,
                    EventsId,
                    LeagueGroupName,
                    LeagueGroupDesc,
                    GroupType,
                    EnrollWay,
                    GenderLimit,
                    MaleBirthdayMin,
                    MaleBirthdayMax,
                    FemaleBirthdayMin,
                    FemaleBirthdayMax,
                    AthletesMin,
                    AthletesMax,
                    MaleAthletesMin,
                    MaleAthletesMax,
                    FemaleAthletesMin,
                    FemaleAthletesMax,
                    EnrollQuotaLimitRadio: !!EnrollQuotaLimit,
                    EnrollQuotaLimit: EnrollQuotaLimit || '',
                }
            });
            //法律文件
            let legalFiles = InstrumentInfo || [];
            this.legalFiles = legalFiles.map(item=>{
                let name = item.InstrumentName,
                    url = item.InstrumentUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                return {
                    url,
                    name: name.substr(0, name.lastIndexOf('.')) || name,
                    size: '',
                    loading: false,
                    type
                }
            });
            //报名附件
            let images = PictureFiles || [];
            this.attachmentImages = images.map(item=>{
                return {
                    url: item.FileUrl,
                    loading: false
                }
            })
            let files = DocFiles || [];
            this.attachmentFiles = files.map(item=>{
                let name = item.FileName,
                    url = item.FileUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                return {
                    url,
                    name: name.substr(0, name.lastIndexOf('.')) || name,
                    size: item.FileSize,
                    loading: false,
                    type
                }
            })
        },
        getTeamUserRoleList(RoleInfo){
            if(!this.leagueObj.EventsId)return;
            GetTeamUserRoleList({
                EventsId: this.leagueObj.EventsId
            }).then(data=>{
                if(data.Code == 0){
                    let TeamUserRoleList = data.TeamUserRoleList || [];
                    let arr = [];
                    for(var i=0;i<TeamUserRoleList.length;i++){
                        let obj = TeamUserRoleList[i];
                        arr.push({
                            isExist: true,
                            roleId: obj.RoleId,
                            name: obj.RoleName,
                            isAthlete: obj.IsAthlete,
                            isMerger: obj.IsAthlete != 1,
                            min:null,
                            max:null
                        })
                    }
                    if(RoleInfo && RoleInfo.length > 0){
                        for(var i=0;i<arr.length;i++){
                            let obj = arr[i];
                            let filterArr = RoleInfo.filter(n=>n.RoleId == obj.roleId);
                            if(filterArr.length > 0){
                                let {
                                    RoleId,
                                    RoleName,
                                    IsAthlete,
                                    CanPartTime,
                                    PeopleMin,
                                    PeopleMax
                                } = filterArr[0];
                                arr[i] = {
                                    isExist: true,
                                    roleId: RoleId,
                                    name: RoleId < 1000 ? RoleName : null,
                                    nameValue: RoleId >= 1000 ? RoleName : null,
                                    isAthlete: IsAthlete,
                                    isMerger: CanPartTime == 1,
                                    min: PeopleMin || null,
                                    max: PeopleMax || null
                                };
                            }else{
                                arr[i].isExist = false;
                            }
                        }
                        for(var i=0;i<RoleInfo.length;i++){
                            let {
                                RoleId,
                                RoleName,
                                IsAthlete,
                                CanPartTime,
                                PeopleMin,
                                PeopleMax
                            } = RoleInfo[i];
                            let filterArr = arr.filter(n=>n.roleId == RoleId);
                            if(filterArr.length == 0){
                                arr.push({
                                    isExist: true,
                                    roleId: RoleId,
                                    name: RoleId < 1000 ? RoleName : null,
                                    nameValue: RoleId >= 1000 ? RoleName : null,
                                    isAthlete: IsAthlete,
                                    isMerger: CanPartTime == 1,
                                    min: PeopleMin || null,
                                    max: PeopleMax || null
                                });
                            }
                        }
                    }
                    this.roleList = arr;
                    this.addRole();
                }
            })
        },
        getLeagueEventsGroup(oldGroupList){
            if(!this.leagueObj.SubLeagueId)return;
            GetLeagueEventsGroup({
                SubLeagueId: this.leagueObj.SubLeagueId
            }).then(data=>{
                if(data.Code == 0){
                   var GroupList = data.GroupList;
                   var arr = [];
                   for(var i=0;i<GroupList.length;i++){
                        let obj = GroupList[i];
                        let groupObj = {};
                        let oldGroupObj = (oldGroupList || []).find(item=>item.LeagueGroupName == obj.GroupName && item.GroupType == obj.GroupType);
                        if(oldGroupObj){
                            let {
                                LeagueGroupDesc,
                                GenderLimit,
                                AthletesMin,
                                AthletesMax,
                                MaleAthletesMin,
                                MaleAthletesMax,
                                FemaleAthletesMin,
                                FemaleAthletesMax,
                                EnrollWay: EWay,
                                MaleBirthdayMin: MBMin,
                                MaleBirthdayMax: MBMax,
                                FemaleBirthdayMin: FBMin,
                                FemaleBirthdayMax: FBMax,
                                EnrollQuotaLimit
                            } = oldGroupObj;
                            let EnrollWay = [];
                            if([1,3].indexOf(EWay) > -1){
                                EnrollWay.push(1);
                            }
                            if([2,3].indexOf(EWay) > -1){
                                EnrollWay.push(2);
                            }
                            let MaleBirthdayMin = MBMin ? this.setDate(MBMin) : [null, 1, 1],
                                MaleBirthdayMax = MBMax ? this.setDate(MBMax) : [null, 12, 31],
                                FemaleBirthdayMin = FBMin ? this.setDate(FBMin) : [null, 1, 1],
                                FemaleBirthdayMax = FBMax ? this.setDate(FBMax) : [null, 12, 31];
                            groupObj = {
                                LeagueGroupId: obj.GroupId,
                                EventsId: obj.EventsId,
                                LeagueGroupName: obj.GroupName,
                                LeagueGroupDesc,
                                GroupType: obj.GroupType,
                                EnrollWay,
                                GenderLimit,
                                MaleBirthdayMin,
                                MaleBirthdayMax,
                                FemaleBirthdayMin,
                                FemaleBirthdayMax,
                                AthletesMin,
                                AthletesMax,
                                MaleAthletesMin,
                                MaleAthletesMax,
                                FemaleAthletesMin,
                                FemaleAthletesMax,
                                EnrollQuotaLimitRadio: !!EnrollQuotaLimit,
                                EnrollQuotaLimit: EnrollQuotaLimit || '',
                            }
                        }else{
                            let EnrollWay = [],
                                GenderLimit = 3;
                            if(obj.GroupType == 2){
                                EnrollWay = [1];
                            }else{
                                EnrollWay = [1,2];
                            }
                            if(obj.GroupName.indexOf('男') > -1){
                                GenderLimit = 1;
                            }else if(obj.GroupName.indexOf('女') > -1){
                                GenderLimit = 2;
                            }else if(obj.GroupName.indexOf('混合') > -1){
                                GenderLimit = 4;
                            }
                            groupObj = {
                                LeagueGroupId: obj.GroupId,
                                EventsId: obj.EventsId,
                                LeagueGroupName: obj.GroupName,
                                LeagueGroupDesc: "",
                                GroupType: obj.GroupType,
                                EnrollWay,
                                GenderLimit,
                                MaleBirthdayMin:[null, 1, 1],
                                MaleBirthdayMax:[null, 12, 31],
                                FemaleBirthdayMin:[null, 1, 1],
                                FemaleBirthdayMax:[null, 12, 31],
                                AthletesMin: [1,3].includes(obj.GroupType) ? 1 : null,
                                AthletesMax: null,
                                MaleAthletesMin: null,
                                MaleAthletesMax: null,
                                FemaleAthletesMin: null,
                                FemaleAthletesMax: null,
                                EnrollQuotaLimitRadio: false,
                                EnrollQuotaLimit: '',
                            }
                        }
                        arr.push(groupObj)
                    }
                    this.groups = arr;
                }
            })
        },
        initFieldsOptions(options){
            this.fieldsOptions = options || {
                identity_limit:9,
                sex_limit: 9,
                birthday_limit: 1,
                portrait_photo: 0,
                jersey_number: 0
            };
        },
        initEnrollOptions(options){
            let {
                dpt_enroll_limit = 0,
                dpt_enroll_teamgroup_num_max,
                athlete_enroll_limit = 0,
                athlete_enroll_teamgroup_num_max,
                athlete_enroll_single_or_doublegroup_num_max
            } = options || {};
            this.enrollOptions = {
                teamEnrollLimit: dpt_enroll_limit,
                teamTeamgroupNumber: dpt_enroll_teamgroup_num_max || '',
                athleteEnrollLimit: athlete_enroll_limit,
                athleteTeamgroupNumber: athlete_enroll_teamgroup_num_max || '',
                athleteSinglegroupNumber: athlete_enroll_single_or_doublegroup_num_max || ''
            }
        },
        setDate(date){
            var date = new Date(date);
            return [date.getFullYear(), date.getMonth()+1, date.getDate()];
        },
        addRole(){
            var roleList = this.roleList;
            var obj = roleList[roleList.length - 1];
            if(roleList.length == 0 || obj.name || obj.nameValue){
                roleList.push({
                    isExist: true,
                    nameValue: null,
                    isAthlete: 0,
                    isMerger: true,
                    min:null,
                    max:null
                })
                this.$set(this,'roleList',roleList)
            }else{
                this.$message.error('请先填写前一个的身份名称');
            }
        },
        removeRole(index){
            var roleList = this.roleList;
            roleList.splice(index,1);
        },
        enrollQuotaLimitChange(value, index){
            if(!+value){
                this.$set(this.groups[index], 'EnrollQuotaLimitRadio', false);
            }else{
                this.$set(this.groups[index], 'EnrollQuotaLimitRadio', true);
            }
        },
        save(){
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    let fieldList = this.fieldList,
                        fieldInfo = [];
                    for(var i=0;i<fieldList.length;i++){
                        let obj = fieldList[i];
                        fieldInfo.push({
                            "LeagueEnrollFieldId": 0,
                            "LeagueEnrollId": this.Id,
                            "FieldName": obj.name,
                            "FieldType": obj.children ? 0 : 1,
                            "FieldDesc": "",
                            "DisplayIndex": i + 1,
                            "IsRequired": obj.isRequired
                        })
                    }
                    let roleList = this.roleList,
                        roleInfo = [];
                    for(var i=0;i<roleList.length;i++){
                        let obj = roleList[i];
                        if(obj.isExist && (obj.name || obj.nameValue)){
                            let min = obj.min,
                                max = obj.max;
                            min = min ? min < 0 ? 0 : min : 0;
                            max = max ? max < 0 ? 0 : max : 0;
                            roleInfo.push({
                                "Id": 0,
                                "LeagueEnrollId": this.Id,
                                "EventsId": this.leagueObj.EventsId,
                                "RoleId": obj.roleId || 0,
                                "RoleName": obj.name || obj.nameValue,
                                "IsAthlete": obj.isAthlete,
                                "CanPartTime": obj.isMerger ? 1 : 0,
                                "OrderBy": i + 1,
                                "PeopleMin": min,
                                "PeopleMax": max
                            })
                        }
                    }
                    let groups = this.groups,
                        groupInfo = [];
                    for(var i=0;i<groups.length;i++){
                        let obj = groups[i];
                        let MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax,
                            MaleAthletesMin,
                            MaleAthletesMax,
                            FemaleAthletesMin,
                            FemaleAthletesMax;
                        if([1,3,4].includes(obj.GenderLimit)){
                            let BMin = obj.MaleBirthdayMin,
                                BMax = obj.MaleBirthdayMax,
                                AMin = obj.MaleAthletesMin,
                                AMax = obj.MaleAthletesMax;
                            AMin = AMin ? AMin < 0 ? null : AMin : null;
                            AMax = AMax ? AMax < 0 ? null : AMax : null;
                            MaleBirthdayMin = BMin[0] ? dateFormat(BMin.join("-"),'yyyy-MM-dd') : null;
                            MaleBirthdayMax = BMax[0] ? dateFormat(BMax.join("-"),'yyyy-MM-dd') : null;
                            MaleAthletesMin = AMin;
                            MaleAthletesMax = AMax;
                        }
                        if([2,3,4].includes(obj.GenderLimit)){
                            let BMin = obj.FemaleBirthdayMin,
                                BMax = obj.FemaleBirthdayMax,
                                AMin = obj.FemaleAthletesMin,
                                AMax = obj.FemaleAthletesMax;
                            AMin = AMin ? AMin < 0 ? null : AMin : null;
                            AMax = AMax ? AMax < 0 ? null : AMax : null;
                            FemaleBirthdayMin = BMin[0] ? dateFormat(BMin.join("-"),'yyyy-MM-dd') : null;
                            FemaleBirthdayMax = BMax[0] ? dateFormat(BMax.join("-"),'yyyy-MM-dd') : null;
                            FemaleAthletesMin = AMin;
                            FemaleAthletesMax = AMax;
                        }
                        let EnrollWay = 1;
                        if(obj.EnrollWay.length >= 2){
                            EnrollWay = 3;
                        }else if(obj.EnrollWay[0] == 1){
                            EnrollWay = 1;
                        }else if(obj.EnrollWay[0] == 2){
                            EnrollWay = 2;
                        }
                        let EnrollQuotaLimit = null;
                        if(obj.EnrollQuotaLimitRadio){
                            EnrollQuotaLimit = +obj.EnrollQuotaLimit;
                        }
                        groupInfo.push({
                            "Id": 0,
                            "LeagueEnrollId": this.Id,
                            "LeagueGroupId": obj.LeagueGroupId,
                            "EventsId": obj.EventsId,
                            "LeagueGroupName": obj.LeagueGroupName,
                            "LeagueGroupDesc": obj.LeagueGroupDesc,
                            "GroupType": obj.GroupType,
                            "EnrollWay": EnrollWay,
                            "GenderLimit": obj.GenderLimit,
                            MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax,
                            "AthletesMin": obj.AthletesMin ? obj.AthletesMin < 0 ? null : obj.AthletesMin : null,
                            "AthletesMax": obj.AthletesMax ? obj.AthletesMax < 0 ? null : obj.AthletesMax : null,
                            MaleAthletesMin,
                            MaleAthletesMax,
                            FemaleAthletesMin,
                            FemaleAthletesMax,
                            EnrollQuotaLimit
                        })
                    }
                    let instrumentInfo = this.legalFiles.filter(item=>!item.loading && item.name).map(item=>({
                        "LeagueInstrumentId": 0,
                        "LeagueEnrollId": this.Id,
                        "InstrumentName": item.name + '.' + item.type,
                        "InstrumentUrl": item.url
                    }));
                    let images = this.attachmentImages.filter(item=>!item.loading).map(item=>({
                        "FileName": item.name,
                        "FileUrl": item.url,
                        "FileType": 1,
                        "FileSize": item.size
                    }))
                    let files = this.attachmentFiles.filter(item=>!item.loading && item.name).map(item=>({
                        "FileName": item.name + '.' + item.type,
                        "FileUrl": item.url,
                        "FileType": 0,
                        "FileSize": item.size
                    }))
                    let {
                        teamEnrollLimit,
                        teamTeamgroupNumber,
                        athleteEnrollLimit,
                        athleteTeamgroupNumber,
                        athleteSinglegroupNumber
                    } = this.enrollOptions;
                    let sendData = {
                        "SettingInfo": {
                            "LeagueBaseInfo": this.leagueObj,
                            "BaseInfo": {
                                "LeagueEnrollId": this.Id,
                                "LeagueId": this.leagueObj.SubLeagueId,
                                "LeagueName": this.leagueObj.SubLeagueName,
                                "EnrollBeginTime": this.form.time[0],
                                "EnrollEndTime": this.form.time[1] || '2099-12-31',
                                "EnrollNotice": this.form.detail,
                                "FieldsOptions": this.fieldsOptions,
                                "EnrollOptions": {
                                    "dpt_enroll_limit": teamEnrollLimit,
                                    "dpt_enroll_teamgroup_num_max": +teamTeamgroupNumber || 0,
                                    "athlete_enroll_limit": athleteEnrollLimit,
                                    "athlete_enroll_teamgroup_num_max": +athleteTeamgroupNumber || 0,
                                    "athlete_enroll_single_or_doublegroup_num_max": +athleteSinglegroupNumber || 0
                                }
                            },
                            "FieldInfo": fieldInfo,
                            "RoleInfo": roleInfo,
                            "GroupInfo": groupInfo,
                            "InstrumentInfo": instrumentInfo,
                            "PictureFiles": images,
                            "DocFiles": files
                        }
                    }
                    if(this.type == 0){
                        CreateLeagueEnroll(sendData).then(data=>{
                            if(data.Code == 0){
                                this.$message.success('报名创建成功，2秒后返回列表');
                                setTimeout(()=>{
                                    this.$router.back();
                                },1500)
                            }
                        })
                    }else{
                        EditLeagueEnroll(sendData).then(data=>{
                            if(data.Code == 0){
                                this.$message.success('报名修改成功，2秒后返回列表');
                                setTimeout(()=>{
                                    this.$router.back();
                                },1500)
                            }
                        })
                    }
                }else{
                    this.$message.error('填写信息有误，请查看！');
                }
            })
        },
    }
}
</script>
<style scoped>
.enrollOptions{
    color: #606266;
}
.enrollOptions p{
    margin-bottom: 5px;
}
.enrollOptions .el-input{
    width: 50px;
}
.fields .el-form-item{
    margin-bottom: 4px;
}
.role {
    margin-left: 30px;
}
.role ul{
    margin-bottom: 20px;
}
.role li{
    display: flex;
    align-items: center;
    color: #606266;
    margin-bottom: 5px;
}
.role li .el-input{
    width: 50px;
}
.role li > div:nth-of-type(1){
    width: 150px;
}
.role li > div:nth-of-type(1) .el-input{
    width: 100px;
}
.role li > div:nth-of-type(3){
    margin-left: 20px;
}
.role li > div:nth-of-type(2) span:nth-of-type(2){
    margin: 0 10px;
}
.group_limit .el-form-item{
    margin-bottom: 10px;
}
.group_limit .more > div{
    margin-bottom: 5px;
}
.group_limit .more.number > div,
.group_limit .more > div:last-of-type{
    margin-bottom: 0;
}
.group_limit .more{
    color: #606266;
}
.group_limit .more.number{
    display: flex;
}
.group_limit .more.number>span{
    margin:0 10px;
}
.group_limit .more .label{
    display: inline-block;
    width: 80px;
    text-align: right;
}
.group_limit .more.number>div:last-of-type .label{
    width: auto;
}
.group_limit .more .el-input{
    width: 50px;
}
</style>
<style>
#EnrollDetail .enrollOptions .el-input input,
#EnrollDetail .role li .el-input input,
#EnrollDetail .group_limit .more .el-input input{
    height: 28px;
    line-height: 28px;
    padding: 0 5px;
}
#EnrollDetail .group_limit .more + .el-form-item__error{
    margin-top: 2px;
}
#EnrollDetail .group_limit .el-form-item__error{
    margin-top: -6px;
}
</style>